/*eslint-disable*/
import api from '../'

class hardSoftConsonantsSchoolPreparingGameItems {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/hardSoftConsonantsSchoolPreparing/items', { params }).then(response => response.data.items);
    }
}

export default hardSoftConsonantsSchoolPreparingGameItems;
